// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AboutRouteImport } from './routes/about'
import { Route as ArticlesRouteImport } from './routes/articles'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as HelpRouteImport } from './routes/help'
import { Route as LegalGuidelinesRouteImport } from './routes/legal-guidelines'
import { Route as PricingRouteImport } from './routes/pricing'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as SecurityRouteImport } from './routes/security'
import { Route as ShopRouteImport } from './routes/shop'
import { Route as TeamsRouteImport } from './routes/teams'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as TutorialRouteImport } from './routes/tutorial'
import { Route as AiIndexRouteImport } from './routes/ai.index'
import { Route as AiContractGeneratorRouteImport } from './routes/ai.contract-generator'
import { Route as AiEmailWriterRouteImport } from './routes/ai.email-writer'
import { Route as AiLeadFinderRouteImport } from './routes/ai.lead-finder'
import { Route as ArticlesIndexRouteImport } from './routes/articles.index'
import { Route as ArticlesSplatRouteImport } from './routes/articles.$'
import { Route as ElIndexRouteImport } from './routes/el.index'
import { Route as ElSplatRouteImport } from './routes/el.$'
import { Route as ElAboutRouteImport } from './routes/el.about'
import { Route as ElContactRouteImport } from './routes/el.contact'
import { Route as ElPricingRouteImport } from './routes/el.pricing'
import { Route as ElShopRouteImport } from './routes/el.shop'
import { Route as ElTeamsRouteImport } from './routes/el.teams'
import { Route as HelpIndexRouteImport } from './routes/help.index'
import { Route as HelpSplatRouteImport } from './routes/help.$'
import { Route as HomeIndexRouteImport } from './routes/home/index'
import { Route as LegalIndexRouteImport } from './routes/legal.index'
import { Route as LegalAffiliateGlobalRouteImport } from './routes/legal.affiliate-global'
import { Route as LegalAffiliateVietnamRouteImport } from './routes/legal.affiliate-vietnam'
import { Route as LegalAmlGlobalRouteImport } from './routes/legal.aml-global'
import { Route as LegalAmlVietnamRouteImport } from './routes/legal.aml-vietnam'
import { Route as LegalAntiSpamRouteImport } from './routes/legal.anti-spam'
import { Route as LegalKycGlobalRouteImport } from './routes/legal.kyc-global'
import { Route as LegalKycVietnamRouteImport } from './routes/legal.kyc-vietnam'
import { Route as LegalRetailerGlobalRouteImport } from './routes/legal.retailer-global'
import { Route as LegalRetailerVietnamRouteImport } from './routes/legal.retailer-vietnam'
import { Route as LegalReturnsRouteImport } from './routes/legal.returns'
import { Route as LegalTicketingGlobalRouteImport } from './routes/legal.ticketing-global'
import { Route as LegalTicketingVietnamRouteImport } from './routes/legal.ticketing-vietnam'
import { Route as OrdersClaimRouteImport } from './routes/orders.claim'
import { Route as PlatformIndexRouteImport } from './routes/platform/index'
import { Route as PlatformAiRouteImport } from './routes/platform/ai'
import { Route as PlatformAiEnrichmentRouteImport } from './routes/platform/ai-enrichment'
import { Route as PlatformAiSuiteRouteImport } from './routes/platform/ai-suite'
import { Route as PlatformAiToolsRouteImport } from './routes/platform/ai-tools'
import { Route as PlatformAnalyticsRouteImport } from './routes/platform/analytics'
import { Route as PlatformAutomationsRouteImport } from './routes/platform/automations'
import { Route as PlatformBookingsRouteImport } from './routes/platform/bookings'
import { Route as PlatformCardsRouteImport } from './routes/platform/cards'
import { Route as PlatformContactsRouteImport } from './routes/platform/contacts'
import { Route as PlatformContractsRouteImport } from './routes/platform/contracts'
import { Route as PlatformCrmRouteImport } from './routes/platform/crm'
import { Route as PlatformEventsRouteImport } from './routes/platform/events'
import { Route as PlatformIdentityAndSharingRouteImport } from './routes/platform/identity-and-sharing'
import { Route as PlatformIntegrationsRouteImport } from './routes/platform/integrations'
import { Route as PlatformMeetingsRouteImport } from './routes/platform/meetings'
import { Route as PlatformNfcRouteImport } from './routes/platform/nfc'
import { Route as PlatformPipelinesRouteImport } from './routes/platform/pipelines'
import { Route as PlatformReviewsRouteImport } from './routes/platform/reviews'
import { Route as PlatformRunYourBusinessRouteImport } from './routes/platform/run-your-business'
import { Route as PlatformScoutRouteImport } from './routes/platform/scout'
import { Route as PlatformSharingRouteImport } from './routes/platform/sharing'
import { Route as PlatformTasksRouteImport } from './routes/platform/tasks'
import { Route as QuoteTokenRouteImport } from './routes/quote.$token'
import { Route as SaleIdRouteImport } from './routes/sale.$id'
import { Route as Shop24ktGoldRouteImport } from './routes/shop_.24kt-gold'
import { Route as ShopBambooRouteImport } from './routes/shop_.bamboo'
import { Route as ShopBlackPvcRouteImport } from './routes/shop_.black-pvc'
import { Route as ShopGoogleReviewRouteImport } from './routes/shop_.google-review'
import { Route as ShopMetalRouteImport } from './routes/shop_.metal'
import { Route as ShopWhitePvcRouteImport } from './routes/shop_.white-pvc'
import { Route as SolutionsIndexRouteImport } from './routes/solutions/index'
import { Route as SolutionsEnterpriseRouteImport } from './routes/solutions/enterprise'
import { Route as SolutionsFoundersRouteImport } from './routes/solutions/founders'
import { Route as SolutionsRealEstateRouteImport } from './routes/solutions/real-estate'
import { Route as SolutionsSalesRouteImport } from './routes/solutions/sales'
import { Route as ViIndexRouteImport } from './routes/vi.index'
import { Route as ViAboutRouteImport } from './routes/vi.about'
import { Route as ViArticlesRouteImport } from './routes/vi.articles'
import { Route as ViContactRouteImport } from './routes/vi.contact'
import { Route as ViHelpRouteImport } from './routes/vi.help'
import { Route as ViLegalGuidelinesRouteImport } from './routes/vi.legal-guidelines'
import { Route as ViPricingRouteImport } from './routes/vi.pricing'
import { Route as ViPrivacyRouteImport } from './routes/vi.privacy'
import { Route as ViSecurityRouteImport } from './routes/vi.security'
import { Route as ViShopRouteImport } from './routes/vi.shop'
import { Route as ViTeamsRouteImport } from './routes/vi.teams'
import { Route as ViTermsRouteImport } from './routes/vi.terms'
import { Route as CheckoutIdSuccessRouteImport } from './routes/checkout.$id_.success'
import { Route as ElPlatformIndexRouteImport } from './routes/el.platform.index'
import { Route as ElPlatformAiRouteImport } from './routes/el.platform.ai'
import { Route as ElPlatformAiEnrichmentRouteImport } from './routes/el.platform.ai-enrichment'
import { Route as ElPlatformAiSuiteRouteImport } from './routes/el.platform.ai-suite'
import { Route as ElPlatformAiToolsRouteImport } from './routes/el.platform.ai-tools'
import { Route as ElPlatformAnalyticsRouteImport } from './routes/el.platform.analytics'
import { Route as ElPlatformAutomationsRouteImport } from './routes/el.platform.automations'
import { Route as ElPlatformBookingsRouteImport } from './routes/el.platform.bookings'
import { Route as ElPlatformCardsRouteImport } from './routes/el.platform.cards'
import { Route as ElPlatformContactsRouteImport } from './routes/el.platform.contacts'
import { Route as ElPlatformContractsRouteImport } from './routes/el.platform.contracts'
import { Route as ElPlatformCrmRouteImport } from './routes/el.platform.crm'
import { Route as ElPlatformIdentityAndSharingRouteImport } from './routes/el.platform.identity-and-sharing'
import { Route as ElPlatformIntegrationsRouteImport } from './routes/el.platform.integrations'
import { Route as ElPlatformNfcRouteImport } from './routes/el.platform.nfc'
import { Route as ElPlatformPipelinesRouteImport } from './routes/el.platform.pipelines'
import { Route as ElPlatformReviewsRouteImport } from './routes/el.platform.reviews'
import { Route as ElPlatformRunYourBusinessRouteImport } from './routes/el.platform.run-your-business'
import { Route as ElPlatformSharingRouteImport } from './routes/el.platform.sharing'
import { Route as ElShop24ktGoldRouteImport } from './routes/el.shop_.24kt-gold'
import { Route as ElShopBambooRouteImport } from './routes/el.shop_.bamboo'
import { Route as ElShopBlackPvcRouteImport } from './routes/el.shop_.black-pvc'
import { Route as ElShopGoogleReviewRouteImport } from './routes/el.shop_.google-review'
import { Route as ElShopMetalRouteImport } from './routes/el.shop_.metal'
import { Route as ElShopWhitePvcRouteImport } from './routes/el.shop_.white-pvc'
import { Route as ElSolutionsIndexRouteImport } from './routes/el.solutions.index'
import { Route as ElSolutionsEnterpriseRouteImport } from './routes/el.solutions.enterprise'
import { Route as ElSolutionsFoundersRouteImport } from './routes/el.solutions.founders'
import { Route as ElSolutionsRealEstateRouteImport } from './routes/el.solutions.real-estate'
import { Route as ElSolutionsSalesRouteImport } from './routes/el.solutions.sales'
import { Route as OrdersIdCustomizeRouteImport } from './routes/orders.$id_.customize'
import { Route as OrdersIdInvoiceRouteImport } from './routes/orders.$id_.invoice'
import { Route as OrdersIdStatusRouteImport } from './routes/orders.$id_.status'
import { Route as PlatformNetworkingIndexRouteImport } from './routes/platform/networking/index'
import { Route as PlatformNetworkingEmailSignatureRouteImport } from './routes/platform/networking/email-signature'
import { Route as PlatformNetworkingLeadExchangeRouteImport } from './routes/platform/networking/lead-exchange'
import { Route as PlatformNetworkingPinProtectionRouteImport } from './routes/platform/networking/pin-protection'
import { Route as PlatformNetworkingQrCodeRouteImport } from './routes/platform/networking/qr-code'
import { Route as PlatformNetworkingWalletRouteImport } from './routes/platform/networking/wallet'
import { Route as PlatformNetworkingWelcomeEmailRouteImport } from './routes/platform/networking/welcome-email'
import { Route as ViAiIndexRouteImport } from './routes/vi.ai.index'
import { Route as ViAiContractGeneratorRouteImport } from './routes/vi.ai.contract-generator'
import { Route as ViAiEmailWriterRouteImport } from './routes/vi.ai.email-writer'
import { Route as ViAiLeadFinderRouteImport } from './routes/vi.ai.lead-finder'
import { Route as ViArticlesIndexRouteImport } from './routes/vi.articles.index'
import { Route as ViArticlesSplatRouteImport } from './routes/vi.articles.$'
import { Route as ViHelpIndexRouteImport } from './routes/vi.help.index'
import { Route as ViHelpSplatRouteImport } from './routes/vi.help.$'
import { Route as ViLegalIndexRouteImport } from './routes/vi.legal.index'
import { Route as ViLegalAffiliateGlobalRouteImport } from './routes/vi.legal.affiliate-global'
import { Route as ViLegalAffiliateVietnamRouteImport } from './routes/vi.legal.affiliate-vietnam'
import { Route as ViLegalAmlGlobalRouteImport } from './routes/vi.legal.aml-global'
import { Route as ViLegalAmlVietnamRouteImport } from './routes/vi.legal.aml-vietnam'
import { Route as ViLegalAntiSpamRouteImport } from './routes/vi.legal.anti-spam'
import { Route as ViLegalKycGlobalRouteImport } from './routes/vi.legal.kyc-global'
import { Route as ViLegalKycVietnamRouteImport } from './routes/vi.legal.kyc-vietnam'
import { Route as ViLegalRetailerGlobalRouteImport } from './routes/vi.legal.retailer-global'
import { Route as ViLegalRetailerVietnamRouteImport } from './routes/vi.legal.retailer-vietnam'
import { Route as ViLegalReturnsRouteImport } from './routes/vi.legal.returns'
import { Route as ViLegalTicketingGlobalRouteImport } from './routes/vi.legal.ticketing-global'
import { Route as ViLegalTicketingVietnamRouteImport } from './routes/vi.legal.ticketing-vietnam'
import { Route as ViPlatformIndexRouteImport } from './routes/vi.platform.index'
import { Route as ViPlatformAiRouteImport } from './routes/vi.platform.ai'
import { Route as ViPlatformAiEnrichmentRouteImport } from './routes/vi.platform.ai-enrichment'
import { Route as ViPlatformAiSuiteRouteImport } from './routes/vi.platform.ai-suite'
import { Route as ViPlatformAiToolsRouteImport } from './routes/vi.platform.ai-tools'
import { Route as ViPlatformAnalyticsRouteImport } from './routes/vi.platform.analytics'
import { Route as ViPlatformAutomationsRouteImport } from './routes/vi.platform.automations'
import { Route as ViPlatformBookingsRouteImport } from './routes/vi.platform.bookings'
import { Route as ViPlatformCardsRouteImport } from './routes/vi.platform.cards'
import { Route as ViPlatformContactsRouteImport } from './routes/vi.platform.contacts'
import { Route as ViPlatformContractsRouteImport } from './routes/vi.platform.contracts'
import { Route as ViPlatformCrmRouteImport } from './routes/vi.platform.crm'
import { Route as ViPlatformEventsRouteImport } from './routes/vi.platform.events'
import { Route as ViPlatformIdentityAndSharingRouteImport } from './routes/vi.platform.identity-and-sharing'
import { Route as ViPlatformIntegrationsRouteImport } from './routes/vi.platform.integrations'
import { Route as ViPlatformMeetingsRouteImport } from './routes/vi.platform.meetings'
import { Route as ViPlatformNfcRouteImport } from './routes/vi.platform.nfc'
import { Route as ViPlatformPipelinesRouteImport } from './routes/vi.platform.pipelines'
import { Route as ViPlatformReviewsRouteImport } from './routes/vi.platform.reviews'
import { Route as ViPlatformRunYourBusinessRouteImport } from './routes/vi.platform.run-your-business'
import { Route as ViPlatformScoutRouteImport } from './routes/vi.platform.scout'
import { Route as ViPlatformSharingRouteImport } from './routes/vi.platform.sharing'
import { Route as ViPlatformTasksRouteImport } from './routes/vi.platform.tasks'
import { Route as ViShop24ktGoldRouteImport } from './routes/vi.shop_.24kt-gold'
import { Route as ViShopBambooRouteImport } from './routes/vi.shop_.bamboo'
import { Route as ViShopBlackPvcRouteImport } from './routes/vi.shop_.black-pvc'
import { Route as ViShopGoogleReviewRouteImport } from './routes/vi.shop_.google-review'
import { Route as ViShopMetalRouteImport } from './routes/vi.shop_.metal'
import { Route as ViShopWhitePvcRouteImport } from './routes/vi.shop_.white-pvc'
import { Route as ViSolutionsIndexRouteImport } from './routes/vi.solutions.index'
import { Route as ViSolutionsEnterpriseRouteImport } from './routes/vi.solutions.enterprise'
import { Route as ViSolutionsFoundersRouteImport } from './routes/vi.solutions.founders'
import { Route as ViSolutionsRealEstateRouteImport } from './routes/vi.solutions.real-estate'
import { Route as ViSolutionsSalesRouteImport } from './routes/vi.solutions.sales'
import { Route as ViPlatformNetworkingIndexRouteImport } from './routes/vi.platform.networking.index'
import { Route as ViPlatformNetworkingEmailSignatureRouteImport } from './routes/vi.platform.networking.email-signature'
import { Route as ViPlatformNetworkingLeadExchangeRouteImport } from './routes/vi.platform.networking.lead-exchange'
import { Route as ViPlatformNetworkingPinProtectionRouteImport } from './routes/vi.platform.networking.pin-protection'
import { Route as ViPlatformNetworkingQrCodeRouteImport } from './routes/vi.platform.networking.qr-code'
import { Route as ViPlatformNetworkingWalletRouteImport } from './routes/vi.platform.networking.wallet'
import { Route as ViPlatformNetworkingWelcomeEmailRouteImport } from './routes/vi.platform.networking.welcome-email'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const ArticlesRoute = ArticlesRouteImport.update({
            id: '/articles',path: '/articles',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const HelpRoute = HelpRouteImport.update({
            id: '/help',path: '/help',getParentRoute: () => rootRouteImport
          })
const LegalGuidelinesRoute = LegalGuidelinesRouteImport.update({
            id: '/legal-guidelines',path: '/legal-guidelines',getParentRoute: () => rootRouteImport
          })
const PricingRoute = PricingRouteImport.update({
            id: '/pricing',path: '/pricing',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const SecurityRoute = SecurityRouteImport.update({
            id: '/security',path: '/security',getParentRoute: () => rootRouteImport
          })
const ShopRoute = ShopRouteImport.update({
            id: '/shop',path: '/shop',getParentRoute: () => rootRouteImport
          })
const TeamsRoute = TeamsRouteImport.update({
            id: '/teams',path: '/teams',getParentRoute: () => rootRouteImport
          })
const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const TutorialRoute = TutorialRouteImport.update({
            id: '/tutorial',path: '/tutorial',getParentRoute: () => rootRouteImport
          })
const AiIndexRoute = AiIndexRouteImport.update({
            id: '/ai/',path: '/ai/',getParentRoute: () => rootRouteImport
          })
const AiContractGeneratorRoute = AiContractGeneratorRouteImport.update({
            id: '/ai/contract-generator',path: '/ai/contract-generator',getParentRoute: () => rootRouteImport
          })
const AiEmailWriterRoute = AiEmailWriterRouteImport.update({
            id: '/ai/email-writer',path: '/ai/email-writer',getParentRoute: () => rootRouteImport
          })
const AiLeadFinderRoute = AiLeadFinderRouteImport.update({
            id: '/ai/lead-finder',path: '/ai/lead-finder',getParentRoute: () => rootRouteImport
          })
const ArticlesIndexRoute = ArticlesIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => ArticlesRoute
          })
const ArticlesSplatRoute = ArticlesSplatRouteImport.update({
            id: '/$',path: '/$',getParentRoute: () => ArticlesRoute
          })
const ElIndexRoute = ElIndexRouteImport.update({
            id: '/el/',path: '/el/',getParentRoute: () => rootRouteImport
          })
const ElSplatRoute = ElSplatRouteImport.update({
            id: '/el/$',path: '/el/$',getParentRoute: () => rootRouteImport
          })
const ElAboutRoute = ElAboutRouteImport.update({
            id: '/el/about',path: '/el/about',getParentRoute: () => rootRouteImport
          })
const ElContactRoute = ElContactRouteImport.update({
            id: '/el/contact',path: '/el/contact',getParentRoute: () => rootRouteImport
          })
const ElPricingRoute = ElPricingRouteImport.update({
            id: '/el/pricing',path: '/el/pricing',getParentRoute: () => rootRouteImport
          })
const ElShopRoute = ElShopRouteImport.update({
            id: '/el/shop',path: '/el/shop',getParentRoute: () => rootRouteImport
          })
const ElTeamsRoute = ElTeamsRouteImport.update({
            id: '/el/teams',path: '/el/teams',getParentRoute: () => rootRouteImport
          })
const HelpIndexRoute = HelpIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => HelpRoute
          })
const HelpSplatRoute = HelpSplatRouteImport.update({
            id: '/$',path: '/$',getParentRoute: () => HelpRoute
          })
const HomeIndexRoute = HomeIndexRouteImport.update({
            id: '/home/',path: '/home/',getParentRoute: () => rootRouteImport
          })
const LegalIndexRoute = LegalIndexRouteImport.update({
            id: '/legal/',path: '/legal/',getParentRoute: () => rootRouteImport
          })
const LegalAffiliateGlobalRoute = LegalAffiliateGlobalRouteImport.update({
            id: '/legal/affiliate-global',path: '/legal/affiliate-global',getParentRoute: () => rootRouteImport
          })
const LegalAffiliateVietnamRoute = LegalAffiliateVietnamRouteImport.update({
            id: '/legal/affiliate-vietnam',path: '/legal/affiliate-vietnam',getParentRoute: () => rootRouteImport
          })
const LegalAmlGlobalRoute = LegalAmlGlobalRouteImport.update({
            id: '/legal/aml-global',path: '/legal/aml-global',getParentRoute: () => rootRouteImport
          })
const LegalAmlVietnamRoute = LegalAmlVietnamRouteImport.update({
            id: '/legal/aml-vietnam',path: '/legal/aml-vietnam',getParentRoute: () => rootRouteImport
          })
const LegalAntiSpamRoute = LegalAntiSpamRouteImport.update({
            id: '/legal/anti-spam',path: '/legal/anti-spam',getParentRoute: () => rootRouteImport
          })
const LegalKycGlobalRoute = LegalKycGlobalRouteImport.update({
            id: '/legal/kyc-global',path: '/legal/kyc-global',getParentRoute: () => rootRouteImport
          })
const LegalKycVietnamRoute = LegalKycVietnamRouteImport.update({
            id: '/legal/kyc-vietnam',path: '/legal/kyc-vietnam',getParentRoute: () => rootRouteImport
          })
const LegalRetailerGlobalRoute = LegalRetailerGlobalRouteImport.update({
            id: '/legal/retailer-global',path: '/legal/retailer-global',getParentRoute: () => rootRouteImport
          })
const LegalRetailerVietnamRoute = LegalRetailerVietnamRouteImport.update({
            id: '/legal/retailer-vietnam',path: '/legal/retailer-vietnam',getParentRoute: () => rootRouteImport
          })
const LegalReturnsRoute = LegalReturnsRouteImport.update({
            id: '/legal/returns',path: '/legal/returns',getParentRoute: () => rootRouteImport
          })
const LegalTicketingGlobalRoute = LegalTicketingGlobalRouteImport.update({
            id: '/legal/ticketing-global',path: '/legal/ticketing-global',getParentRoute: () => rootRouteImport
          })
const LegalTicketingVietnamRoute = LegalTicketingVietnamRouteImport.update({
            id: '/legal/ticketing-vietnam',path: '/legal/ticketing-vietnam',getParentRoute: () => rootRouteImport
          })
const OrdersClaimRoute = OrdersClaimRouteImport.update({
            id: '/orders/claim',path: '/orders/claim',getParentRoute: () => rootRouteImport
          })
const PlatformIndexRoute = PlatformIndexRouteImport.update({
            id: '/platform/',path: '/platform/',getParentRoute: () => rootRouteImport
          })
const PlatformAiRoute = PlatformAiRouteImport.update({
            id: '/platform/ai',path: '/platform/ai',getParentRoute: () => rootRouteImport
          })
const PlatformAiEnrichmentRoute = PlatformAiEnrichmentRouteImport.update({
            id: '/platform/ai-enrichment',path: '/platform/ai-enrichment',getParentRoute: () => rootRouteImport
          })
const PlatformAiSuiteRoute = PlatformAiSuiteRouteImport.update({
            id: '/platform/ai-suite',path: '/platform/ai-suite',getParentRoute: () => rootRouteImport
          })
const PlatformAiToolsRoute = PlatformAiToolsRouteImport.update({
            id: '/platform/ai-tools',path: '/platform/ai-tools',getParentRoute: () => rootRouteImport
          })
const PlatformAnalyticsRoute = PlatformAnalyticsRouteImport.update({
            id: '/platform/analytics',path: '/platform/analytics',getParentRoute: () => rootRouteImport
          })
const PlatformAutomationsRoute = PlatformAutomationsRouteImport.update({
            id: '/platform/automations',path: '/platform/automations',getParentRoute: () => rootRouteImport
          })
const PlatformBookingsRoute = PlatformBookingsRouteImport.update({
            id: '/platform/bookings',path: '/platform/bookings',getParentRoute: () => rootRouteImport
          })
const PlatformCardsRoute = PlatformCardsRouteImport.update({
            id: '/platform/cards',path: '/platform/cards',getParentRoute: () => rootRouteImport
          })
const PlatformContactsRoute = PlatformContactsRouteImport.update({
            id: '/platform/contacts',path: '/platform/contacts',getParentRoute: () => rootRouteImport
          })
const PlatformContractsRoute = PlatformContractsRouteImport.update({
            id: '/platform/contracts',path: '/platform/contracts',getParentRoute: () => rootRouteImport
          })
const PlatformCrmRoute = PlatformCrmRouteImport.update({
            id: '/platform/crm',path: '/platform/crm',getParentRoute: () => rootRouteImport
          })
const PlatformEventsRoute = PlatformEventsRouteImport.update({
            id: '/platform/events',path: '/platform/events',getParentRoute: () => rootRouteImport
          })
const PlatformIdentityAndSharingRoute = PlatformIdentityAndSharingRouteImport.update({
            id: '/platform/identity-and-sharing',path: '/platform/identity-and-sharing',getParentRoute: () => rootRouteImport
          })
const PlatformIntegrationsRoute = PlatformIntegrationsRouteImport.update({
            id: '/platform/integrations',path: '/platform/integrations',getParentRoute: () => rootRouteImport
          })
const PlatformMeetingsRoute = PlatformMeetingsRouteImport.update({
            id: '/platform/meetings',path: '/platform/meetings',getParentRoute: () => rootRouteImport
          })
const PlatformNfcRoute = PlatformNfcRouteImport.update({
            id: '/platform/nfc',path: '/platform/nfc',getParentRoute: () => rootRouteImport
          })
const PlatformPipelinesRoute = PlatformPipelinesRouteImport.update({
            id: '/platform/pipelines',path: '/platform/pipelines',getParentRoute: () => rootRouteImport
          })
const PlatformReviewsRoute = PlatformReviewsRouteImport.update({
            id: '/platform/reviews',path: '/platform/reviews',getParentRoute: () => rootRouteImport
          })
const PlatformRunYourBusinessRoute = PlatformRunYourBusinessRouteImport.update({
            id: '/platform/run-your-business',path: '/platform/run-your-business',getParentRoute: () => rootRouteImport
          })
const PlatformScoutRoute = PlatformScoutRouteImport.update({
            id: '/platform/scout',path: '/platform/scout',getParentRoute: () => rootRouteImport
          })
const PlatformSharingRoute = PlatformSharingRouteImport.update({
            id: '/platform/sharing',path: '/platform/sharing',getParentRoute: () => rootRouteImport
          })
const PlatformTasksRoute = PlatformTasksRouteImport.update({
            id: '/platform/tasks',path: '/platform/tasks',getParentRoute: () => rootRouteImport
          })
const QuoteTokenRoute = QuoteTokenRouteImport.update({
            id: '/quote/$token',path: '/quote/$token',getParentRoute: () => rootRouteImport
          })
const SaleIdRoute = SaleIdRouteImport.update({
            id: '/sale/$id',path: '/sale/$id',getParentRoute: () => rootRouteImport
          })
const Shop24ktGoldRoute = Shop24ktGoldRouteImport.update({
            id: '/shop_/24kt-gold',path: '/shop/24kt-gold',getParentRoute: () => rootRouteImport
          })
const ShopBambooRoute = ShopBambooRouteImport.update({
            id: '/shop_/bamboo',path: '/shop/bamboo',getParentRoute: () => rootRouteImport
          })
const ShopBlackPvcRoute = ShopBlackPvcRouteImport.update({
            id: '/shop_/black-pvc',path: '/shop/black-pvc',getParentRoute: () => rootRouteImport
          })
const ShopGoogleReviewRoute = ShopGoogleReviewRouteImport.update({
            id: '/shop_/google-review',path: '/shop/google-review',getParentRoute: () => rootRouteImport
          })
const ShopMetalRoute = ShopMetalRouteImport.update({
            id: '/shop_/metal',path: '/shop/metal',getParentRoute: () => rootRouteImport
          })
const ShopWhitePvcRoute = ShopWhitePvcRouteImport.update({
            id: '/shop_/white-pvc',path: '/shop/white-pvc',getParentRoute: () => rootRouteImport
          })
const SolutionsIndexRoute = SolutionsIndexRouteImport.update({
            id: '/solutions/',path: '/solutions/',getParentRoute: () => rootRouteImport
          })
const SolutionsEnterpriseRoute = SolutionsEnterpriseRouteImport.update({
            id: '/solutions/enterprise',path: '/solutions/enterprise',getParentRoute: () => rootRouteImport
          })
const SolutionsFoundersRoute = SolutionsFoundersRouteImport.update({
            id: '/solutions/founders',path: '/solutions/founders',getParentRoute: () => rootRouteImport
          })
const SolutionsRealEstateRoute = SolutionsRealEstateRouteImport.update({
            id: '/solutions/real-estate',path: '/solutions/real-estate',getParentRoute: () => rootRouteImport
          })
const SolutionsSalesRoute = SolutionsSalesRouteImport.update({
            id: '/solutions/sales',path: '/solutions/sales',getParentRoute: () => rootRouteImport
          })
const ViIndexRoute = ViIndexRouteImport.update({
            id: '/vi/',path: '/vi/',getParentRoute: () => rootRouteImport
          })
const ViAboutRoute = ViAboutRouteImport.update({
            id: '/vi/about',path: '/vi/about',getParentRoute: () => rootRouteImport
          })
const ViArticlesRoute = ViArticlesRouteImport.update({
            id: '/vi/articles',path: '/vi/articles',getParentRoute: () => rootRouteImport
          })
const ViContactRoute = ViContactRouteImport.update({
            id: '/vi/contact',path: '/vi/contact',getParentRoute: () => rootRouteImport
          })
const ViHelpRoute = ViHelpRouteImport.update({
            id: '/vi/help',path: '/vi/help',getParentRoute: () => rootRouteImport
          })
const ViLegalGuidelinesRoute = ViLegalGuidelinesRouteImport.update({
            id: '/vi/legal-guidelines',path: '/vi/legal-guidelines',getParentRoute: () => rootRouteImport
          })
const ViPricingRoute = ViPricingRouteImport.update({
            id: '/vi/pricing',path: '/vi/pricing',getParentRoute: () => rootRouteImport
          })
const ViPrivacyRoute = ViPrivacyRouteImport.update({
            id: '/vi/privacy',path: '/vi/privacy',getParentRoute: () => rootRouteImport
          })
const ViSecurityRoute = ViSecurityRouteImport.update({
            id: '/vi/security',path: '/vi/security',getParentRoute: () => rootRouteImport
          })
const ViShopRoute = ViShopRouteImport.update({
            id: '/vi/shop',path: '/vi/shop',getParentRoute: () => rootRouteImport
          })
const ViTeamsRoute = ViTeamsRouteImport.update({
            id: '/vi/teams',path: '/vi/teams',getParentRoute: () => rootRouteImport
          })
const ViTermsRoute = ViTermsRouteImport.update({
            id: '/vi/terms',path: '/vi/terms',getParentRoute: () => rootRouteImport
          })
const CheckoutIdSuccessRoute = CheckoutIdSuccessRouteImport.update({
            id: '/checkout/$id_/success',path: '/checkout/$id/success',getParentRoute: () => rootRouteImport
          })
const ElPlatformIndexRoute = ElPlatformIndexRouteImport.update({
            id: '/el/platform/',path: '/el/platform/',getParentRoute: () => rootRouteImport
          })
const ElPlatformAiRoute = ElPlatformAiRouteImport.update({
            id: '/el/platform/ai',path: '/el/platform/ai',getParentRoute: () => rootRouteImport
          })
const ElPlatformAiEnrichmentRoute = ElPlatformAiEnrichmentRouteImport.update({
            id: '/el/platform/ai-enrichment',path: '/el/platform/ai-enrichment',getParentRoute: () => rootRouteImport
          })
const ElPlatformAiSuiteRoute = ElPlatformAiSuiteRouteImport.update({
            id: '/el/platform/ai-suite',path: '/el/platform/ai-suite',getParentRoute: () => rootRouteImport
          })
const ElPlatformAiToolsRoute = ElPlatformAiToolsRouteImport.update({
            id: '/el/platform/ai-tools',path: '/el/platform/ai-tools',getParentRoute: () => rootRouteImport
          })
const ElPlatformAnalyticsRoute = ElPlatformAnalyticsRouteImport.update({
            id: '/el/platform/analytics',path: '/el/platform/analytics',getParentRoute: () => rootRouteImport
          })
const ElPlatformAutomationsRoute = ElPlatformAutomationsRouteImport.update({
            id: '/el/platform/automations',path: '/el/platform/automations',getParentRoute: () => rootRouteImport
          })
const ElPlatformBookingsRoute = ElPlatformBookingsRouteImport.update({
            id: '/el/platform/bookings',path: '/el/platform/bookings',getParentRoute: () => rootRouteImport
          })
const ElPlatformCardsRoute = ElPlatformCardsRouteImport.update({
            id: '/el/platform/cards',path: '/el/platform/cards',getParentRoute: () => rootRouteImport
          })
const ElPlatformContactsRoute = ElPlatformContactsRouteImport.update({
            id: '/el/platform/contacts',path: '/el/platform/contacts',getParentRoute: () => rootRouteImport
          })
const ElPlatformContractsRoute = ElPlatformContractsRouteImport.update({
            id: '/el/platform/contracts',path: '/el/platform/contracts',getParentRoute: () => rootRouteImport
          })
const ElPlatformCrmRoute = ElPlatformCrmRouteImport.update({
            id: '/el/platform/crm',path: '/el/platform/crm',getParentRoute: () => rootRouteImport
          })
const ElPlatformIdentityAndSharingRoute = ElPlatformIdentityAndSharingRouteImport.update({
            id: '/el/platform/identity-and-sharing',path: '/el/platform/identity-and-sharing',getParentRoute: () => rootRouteImport
          })
const ElPlatformIntegrationsRoute = ElPlatformIntegrationsRouteImport.update({
            id: '/el/platform/integrations',path: '/el/platform/integrations',getParentRoute: () => rootRouteImport
          })
const ElPlatformNfcRoute = ElPlatformNfcRouteImport.update({
            id: '/el/platform/nfc',path: '/el/platform/nfc',getParentRoute: () => rootRouteImport
          })
const ElPlatformPipelinesRoute = ElPlatformPipelinesRouteImport.update({
            id: '/el/platform/pipelines',path: '/el/platform/pipelines',getParentRoute: () => rootRouteImport
          })
const ElPlatformReviewsRoute = ElPlatformReviewsRouteImport.update({
            id: '/el/platform/reviews',path: '/el/platform/reviews',getParentRoute: () => rootRouteImport
          })
const ElPlatformRunYourBusinessRoute = ElPlatformRunYourBusinessRouteImport.update({
            id: '/el/platform/run-your-business',path: '/el/platform/run-your-business',getParentRoute: () => rootRouteImport
          })
const ElPlatformSharingRoute = ElPlatformSharingRouteImport.update({
            id: '/el/platform/sharing',path: '/el/platform/sharing',getParentRoute: () => rootRouteImport
          })
const ElShop24ktGoldRoute = ElShop24ktGoldRouteImport.update({
            id: '/el/shop_/24kt-gold',path: '/el/shop/24kt-gold',getParentRoute: () => rootRouteImport
          })
const ElShopBambooRoute = ElShopBambooRouteImport.update({
            id: '/el/shop_/bamboo',path: '/el/shop/bamboo',getParentRoute: () => rootRouteImport
          })
const ElShopBlackPvcRoute = ElShopBlackPvcRouteImport.update({
            id: '/el/shop_/black-pvc',path: '/el/shop/black-pvc',getParentRoute: () => rootRouteImport
          })
const ElShopGoogleReviewRoute = ElShopGoogleReviewRouteImport.update({
            id: '/el/shop_/google-review',path: '/el/shop/google-review',getParentRoute: () => rootRouteImport
          })
const ElShopMetalRoute = ElShopMetalRouteImport.update({
            id: '/el/shop_/metal',path: '/el/shop/metal',getParentRoute: () => rootRouteImport
          })
const ElShopWhitePvcRoute = ElShopWhitePvcRouteImport.update({
            id: '/el/shop_/white-pvc',path: '/el/shop/white-pvc',getParentRoute: () => rootRouteImport
          })
const ElSolutionsIndexRoute = ElSolutionsIndexRouteImport.update({
            id: '/el/solutions/',path: '/el/solutions/',getParentRoute: () => rootRouteImport
          })
const ElSolutionsEnterpriseRoute = ElSolutionsEnterpriseRouteImport.update({
            id: '/el/solutions/enterprise',path: '/el/solutions/enterprise',getParentRoute: () => rootRouteImport
          })
const ElSolutionsFoundersRoute = ElSolutionsFoundersRouteImport.update({
            id: '/el/solutions/founders',path: '/el/solutions/founders',getParentRoute: () => rootRouteImport
          })
const ElSolutionsRealEstateRoute = ElSolutionsRealEstateRouteImport.update({
            id: '/el/solutions/real-estate',path: '/el/solutions/real-estate',getParentRoute: () => rootRouteImport
          })
const ElSolutionsSalesRoute = ElSolutionsSalesRouteImport.update({
            id: '/el/solutions/sales',path: '/el/solutions/sales',getParentRoute: () => rootRouteImport
          })
const OrdersIdCustomizeRoute = OrdersIdCustomizeRouteImport.update({
            id: '/orders/$id_/customize',path: '/orders/$id/customize',getParentRoute: () => rootRouteImport
          })
const OrdersIdInvoiceRoute = OrdersIdInvoiceRouteImport.update({
            id: '/orders/$id_/invoice',path: '/orders/$id/invoice',getParentRoute: () => rootRouteImport
          })
const OrdersIdStatusRoute = OrdersIdStatusRouteImport.update({
            id: '/orders/$id_/status',path: '/orders/$id/status',getParentRoute: () => rootRouteImport
          })
const PlatformNetworkingIndexRoute = PlatformNetworkingIndexRouteImport.update({
            id: '/platform/networking/',path: '/platform/networking/',getParentRoute: () => rootRouteImport
          })
const PlatformNetworkingEmailSignatureRoute = PlatformNetworkingEmailSignatureRouteImport.update({
            id: '/platform/networking/email-signature',path: '/platform/networking/email-signature',getParentRoute: () => rootRouteImport
          })
const PlatformNetworkingLeadExchangeRoute = PlatformNetworkingLeadExchangeRouteImport.update({
            id: '/platform/networking/lead-exchange',path: '/platform/networking/lead-exchange',getParentRoute: () => rootRouteImport
          })
const PlatformNetworkingPinProtectionRoute = PlatformNetworkingPinProtectionRouteImport.update({
            id: '/platform/networking/pin-protection',path: '/platform/networking/pin-protection',getParentRoute: () => rootRouteImport
          })
const PlatformNetworkingQrCodeRoute = PlatformNetworkingQrCodeRouteImport.update({
            id: '/platform/networking/qr-code',path: '/platform/networking/qr-code',getParentRoute: () => rootRouteImport
          })
const PlatformNetworkingWalletRoute = PlatformNetworkingWalletRouteImport.update({
            id: '/platform/networking/wallet',path: '/platform/networking/wallet',getParentRoute: () => rootRouteImport
          })
const PlatformNetworkingWelcomeEmailRoute = PlatformNetworkingWelcomeEmailRouteImport.update({
            id: '/platform/networking/welcome-email',path: '/platform/networking/welcome-email',getParentRoute: () => rootRouteImport
          })
const ViAiIndexRoute = ViAiIndexRouteImport.update({
            id: '/vi/ai/',path: '/vi/ai/',getParentRoute: () => rootRouteImport
          })
const ViAiContractGeneratorRoute = ViAiContractGeneratorRouteImport.update({
            id: '/vi/ai/contract-generator',path: '/vi/ai/contract-generator',getParentRoute: () => rootRouteImport
          })
const ViAiEmailWriterRoute = ViAiEmailWriterRouteImport.update({
            id: '/vi/ai/email-writer',path: '/vi/ai/email-writer',getParentRoute: () => rootRouteImport
          })
const ViAiLeadFinderRoute = ViAiLeadFinderRouteImport.update({
            id: '/vi/ai/lead-finder',path: '/vi/ai/lead-finder',getParentRoute: () => rootRouteImport
          })
const ViArticlesIndexRoute = ViArticlesIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => ViArticlesRoute
          })
const ViArticlesSplatRoute = ViArticlesSplatRouteImport.update({
            id: '/$',path: '/$',getParentRoute: () => ViArticlesRoute
          })
const ViHelpIndexRoute = ViHelpIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => ViHelpRoute
          })
const ViHelpSplatRoute = ViHelpSplatRouteImport.update({
            id: '/$',path: '/$',getParentRoute: () => ViHelpRoute
          })
const ViLegalIndexRoute = ViLegalIndexRouteImport.update({
            id: '/vi/legal/',path: '/vi/legal/',getParentRoute: () => rootRouteImport
          })
const ViLegalAffiliateGlobalRoute = ViLegalAffiliateGlobalRouteImport.update({
            id: '/vi/legal/affiliate-global',path: '/vi/legal/affiliate-global',getParentRoute: () => rootRouteImport
          })
const ViLegalAffiliateVietnamRoute = ViLegalAffiliateVietnamRouteImport.update({
            id: '/vi/legal/affiliate-vietnam',path: '/vi/legal/affiliate-vietnam',getParentRoute: () => rootRouteImport
          })
const ViLegalAmlGlobalRoute = ViLegalAmlGlobalRouteImport.update({
            id: '/vi/legal/aml-global',path: '/vi/legal/aml-global',getParentRoute: () => rootRouteImport
          })
const ViLegalAmlVietnamRoute = ViLegalAmlVietnamRouteImport.update({
            id: '/vi/legal/aml-vietnam',path: '/vi/legal/aml-vietnam',getParentRoute: () => rootRouteImport
          })
const ViLegalAntiSpamRoute = ViLegalAntiSpamRouteImport.update({
            id: '/vi/legal/anti-spam',path: '/vi/legal/anti-spam',getParentRoute: () => rootRouteImport
          })
const ViLegalKycGlobalRoute = ViLegalKycGlobalRouteImport.update({
            id: '/vi/legal/kyc-global',path: '/vi/legal/kyc-global',getParentRoute: () => rootRouteImport
          })
const ViLegalKycVietnamRoute = ViLegalKycVietnamRouteImport.update({
            id: '/vi/legal/kyc-vietnam',path: '/vi/legal/kyc-vietnam',getParentRoute: () => rootRouteImport
          })
const ViLegalRetailerGlobalRoute = ViLegalRetailerGlobalRouteImport.update({
            id: '/vi/legal/retailer-global',path: '/vi/legal/retailer-global',getParentRoute: () => rootRouteImport
          })
const ViLegalRetailerVietnamRoute = ViLegalRetailerVietnamRouteImport.update({
            id: '/vi/legal/retailer-vietnam',path: '/vi/legal/retailer-vietnam',getParentRoute: () => rootRouteImport
          })
const ViLegalReturnsRoute = ViLegalReturnsRouteImport.update({
            id: '/vi/legal/returns',path: '/vi/legal/returns',getParentRoute: () => rootRouteImport
          })
const ViLegalTicketingGlobalRoute = ViLegalTicketingGlobalRouteImport.update({
            id: '/vi/legal/ticketing-global',path: '/vi/legal/ticketing-global',getParentRoute: () => rootRouteImport
          })
const ViLegalTicketingVietnamRoute = ViLegalTicketingVietnamRouteImport.update({
            id: '/vi/legal/ticketing-vietnam',path: '/vi/legal/ticketing-vietnam',getParentRoute: () => rootRouteImport
          })
const ViPlatformIndexRoute = ViPlatformIndexRouteImport.update({
            id: '/vi/platform/',path: '/vi/platform/',getParentRoute: () => rootRouteImport
          })
const ViPlatformAiRoute = ViPlatformAiRouteImport.update({
            id: '/vi/platform/ai',path: '/vi/platform/ai',getParentRoute: () => rootRouteImport
          })
const ViPlatformAiEnrichmentRoute = ViPlatformAiEnrichmentRouteImport.update({
            id: '/vi/platform/ai-enrichment',path: '/vi/platform/ai-enrichment',getParentRoute: () => rootRouteImport
          })
const ViPlatformAiSuiteRoute = ViPlatformAiSuiteRouteImport.update({
            id: '/vi/platform/ai-suite',path: '/vi/platform/ai-suite',getParentRoute: () => rootRouteImport
          })
const ViPlatformAiToolsRoute = ViPlatformAiToolsRouteImport.update({
            id: '/vi/platform/ai-tools',path: '/vi/platform/ai-tools',getParentRoute: () => rootRouteImport
          })
const ViPlatformAnalyticsRoute = ViPlatformAnalyticsRouteImport.update({
            id: '/vi/platform/analytics',path: '/vi/platform/analytics',getParentRoute: () => rootRouteImport
          })
const ViPlatformAutomationsRoute = ViPlatformAutomationsRouteImport.update({
            id: '/vi/platform/automations',path: '/vi/platform/automations',getParentRoute: () => rootRouteImport
          })
const ViPlatformBookingsRoute = ViPlatformBookingsRouteImport.update({
            id: '/vi/platform/bookings',path: '/vi/platform/bookings',getParentRoute: () => rootRouteImport
          })
const ViPlatformCardsRoute = ViPlatformCardsRouteImport.update({
            id: '/vi/platform/cards',path: '/vi/platform/cards',getParentRoute: () => rootRouteImport
          })
const ViPlatformContactsRoute = ViPlatformContactsRouteImport.update({
            id: '/vi/platform/contacts',path: '/vi/platform/contacts',getParentRoute: () => rootRouteImport
          })
const ViPlatformContractsRoute = ViPlatformContractsRouteImport.update({
            id: '/vi/platform/contracts',path: '/vi/platform/contracts',getParentRoute: () => rootRouteImport
          })
const ViPlatformCrmRoute = ViPlatformCrmRouteImport.update({
            id: '/vi/platform/crm',path: '/vi/platform/crm',getParentRoute: () => rootRouteImport
          })
const ViPlatformEventsRoute = ViPlatformEventsRouteImport.update({
            id: '/vi/platform/events',path: '/vi/platform/events',getParentRoute: () => rootRouteImport
          })
const ViPlatformIdentityAndSharingRoute = ViPlatformIdentityAndSharingRouteImport.update({
            id: '/vi/platform/identity-and-sharing',path: '/vi/platform/identity-and-sharing',getParentRoute: () => rootRouteImport
          })
const ViPlatformIntegrationsRoute = ViPlatformIntegrationsRouteImport.update({
            id: '/vi/platform/integrations',path: '/vi/platform/integrations',getParentRoute: () => rootRouteImport
          })
const ViPlatformMeetingsRoute = ViPlatformMeetingsRouteImport.update({
            id: '/vi/platform/meetings',path: '/vi/platform/meetings',getParentRoute: () => rootRouteImport
          })
const ViPlatformNfcRoute = ViPlatformNfcRouteImport.update({
            id: '/vi/platform/nfc',path: '/vi/platform/nfc',getParentRoute: () => rootRouteImport
          })
const ViPlatformPipelinesRoute = ViPlatformPipelinesRouteImport.update({
            id: '/vi/platform/pipelines',path: '/vi/platform/pipelines',getParentRoute: () => rootRouteImport
          })
const ViPlatformReviewsRoute = ViPlatformReviewsRouteImport.update({
            id: '/vi/platform/reviews',path: '/vi/platform/reviews',getParentRoute: () => rootRouteImport
          })
const ViPlatformRunYourBusinessRoute = ViPlatformRunYourBusinessRouteImport.update({
            id: '/vi/platform/run-your-business',path: '/vi/platform/run-your-business',getParentRoute: () => rootRouteImport
          })
const ViPlatformScoutRoute = ViPlatformScoutRouteImport.update({
            id: '/vi/platform/scout',path: '/vi/platform/scout',getParentRoute: () => rootRouteImport
          })
const ViPlatformSharingRoute = ViPlatformSharingRouteImport.update({
            id: '/vi/platform/sharing',path: '/vi/platform/sharing',getParentRoute: () => rootRouteImport
          })
const ViPlatformTasksRoute = ViPlatformTasksRouteImport.update({
            id: '/vi/platform/tasks',path: '/vi/platform/tasks',getParentRoute: () => rootRouteImport
          })
const ViShop24ktGoldRoute = ViShop24ktGoldRouteImport.update({
            id: '/vi/shop_/24kt-gold',path: '/vi/shop/24kt-gold',getParentRoute: () => rootRouteImport
          })
const ViShopBambooRoute = ViShopBambooRouteImport.update({
            id: '/vi/shop_/bamboo',path: '/vi/shop/bamboo',getParentRoute: () => rootRouteImport
          })
const ViShopBlackPvcRoute = ViShopBlackPvcRouteImport.update({
            id: '/vi/shop_/black-pvc',path: '/vi/shop/black-pvc',getParentRoute: () => rootRouteImport
          })
const ViShopGoogleReviewRoute = ViShopGoogleReviewRouteImport.update({
            id: '/vi/shop_/google-review',path: '/vi/shop/google-review',getParentRoute: () => rootRouteImport
          })
const ViShopMetalRoute = ViShopMetalRouteImport.update({
            id: '/vi/shop_/metal',path: '/vi/shop/metal',getParentRoute: () => rootRouteImport
          })
const ViShopWhitePvcRoute = ViShopWhitePvcRouteImport.update({
            id: '/vi/shop_/white-pvc',path: '/vi/shop/white-pvc',getParentRoute: () => rootRouteImport
          })
const ViSolutionsIndexRoute = ViSolutionsIndexRouteImport.update({
            id: '/vi/solutions/',path: '/vi/solutions/',getParentRoute: () => rootRouteImport
          })
const ViSolutionsEnterpriseRoute = ViSolutionsEnterpriseRouteImport.update({
            id: '/vi/solutions/enterprise',path: '/vi/solutions/enterprise',getParentRoute: () => rootRouteImport
          })
const ViSolutionsFoundersRoute = ViSolutionsFoundersRouteImport.update({
            id: '/vi/solutions/founders',path: '/vi/solutions/founders',getParentRoute: () => rootRouteImport
          })
const ViSolutionsRealEstateRoute = ViSolutionsRealEstateRouteImport.update({
            id: '/vi/solutions/real-estate',path: '/vi/solutions/real-estate',getParentRoute: () => rootRouteImport
          })
const ViSolutionsSalesRoute = ViSolutionsSalesRouteImport.update({
            id: '/vi/solutions/sales',path: '/vi/solutions/sales',getParentRoute: () => rootRouteImport
          })
const ViPlatformNetworkingIndexRoute = ViPlatformNetworkingIndexRouteImport.update({
            id: '/vi/platform/networking/',path: '/vi/platform/networking/',getParentRoute: () => rootRouteImport
          })
const ViPlatformNetworkingEmailSignatureRoute = ViPlatformNetworkingEmailSignatureRouteImport.update({
            id: '/vi/platform/networking/email-signature',path: '/vi/platform/networking/email-signature',getParentRoute: () => rootRouteImport
          })
const ViPlatformNetworkingLeadExchangeRoute = ViPlatformNetworkingLeadExchangeRouteImport.update({
            id: '/vi/platform/networking/lead-exchange',path: '/vi/platform/networking/lead-exchange',getParentRoute: () => rootRouteImport
          })
const ViPlatformNetworkingPinProtectionRoute = ViPlatformNetworkingPinProtectionRouteImport.update({
            id: '/vi/platform/networking/pin-protection',path: '/vi/platform/networking/pin-protection',getParentRoute: () => rootRouteImport
          })
const ViPlatformNetworkingQrCodeRoute = ViPlatformNetworkingQrCodeRouteImport.update({
            id: '/vi/platform/networking/qr-code',path: '/vi/platform/networking/qr-code',getParentRoute: () => rootRouteImport
          })
const ViPlatformNetworkingWalletRoute = ViPlatformNetworkingWalletRouteImport.update({
            id: '/vi/platform/networking/wallet',path: '/vi/platform/networking/wallet',getParentRoute: () => rootRouteImport
          })
const ViPlatformNetworkingWelcomeEmailRoute = ViPlatformNetworkingWelcomeEmailRouteImport.update({
            id: '/vi/platform/networking/welcome-email',path: '/vi/platform/networking/welcome-email',getParentRoute: () => rootRouteImport
          })





const ArticlesRouteChildren = {
  ArticlesSplatRoute: ArticlesSplatRoute,ArticlesIndexRoute: ArticlesIndexRoute
}

const ArticlesRouteWithChildren = ArticlesRoute._addFileChildren(ArticlesRouteChildren)




const HelpRouteChildren = {
  HelpSplatRoute: HelpSplatRoute,HelpIndexRoute: HelpIndexRoute
}

const HelpRouteWithChildren = HelpRoute._addFileChildren(HelpRouteChildren)




const ViArticlesRouteChildren = {
  ViArticlesSplatRoute: ViArticlesSplatRoute,ViArticlesIndexRoute: ViArticlesIndexRoute
}

const ViArticlesRouteWithChildren = ViArticlesRoute._addFileChildren(ViArticlesRouteChildren)




const ViHelpRouteChildren = {
  ViHelpSplatRoute: ViHelpSplatRoute,ViHelpIndexRoute: ViHelpIndexRoute
}

const ViHelpRouteWithChildren = ViHelpRoute._addFileChildren(ViHelpRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AboutRoute: AboutRoute,ArticlesRoute: ArticlesRouteWithChildren,ContactRoute: ContactRoute,HelpRoute: HelpRouteWithChildren,LegalGuidelinesRoute: LegalGuidelinesRoute,PricingRoute: PricingRoute,PrivacyRoute: PrivacyRoute,SecurityRoute: SecurityRoute,ShopRoute: ShopRoute,TeamsRoute: TeamsRoute,TermsRoute: TermsRoute,TutorialRoute: TutorialRoute,AiContractGeneratorRoute: AiContractGeneratorRoute,AiEmailWriterRoute: AiEmailWriterRoute,AiLeadFinderRoute: AiLeadFinderRoute,ElSplatRoute: ElSplatRoute,ElAboutRoute: ElAboutRoute,ElContactRoute: ElContactRoute,ElPricingRoute: ElPricingRoute,ElShopRoute: ElShopRoute,ElTeamsRoute: ElTeamsRoute,LegalAffiliateGlobalRoute: LegalAffiliateGlobalRoute,LegalAffiliateVietnamRoute: LegalAffiliateVietnamRoute,LegalAmlGlobalRoute: LegalAmlGlobalRoute,LegalAmlVietnamRoute: LegalAmlVietnamRoute,LegalAntiSpamRoute: LegalAntiSpamRoute,LegalKycGlobalRoute: LegalKycGlobalRoute,LegalKycVietnamRoute: LegalKycVietnamRoute,LegalRetailerGlobalRoute: LegalRetailerGlobalRoute,LegalRetailerVietnamRoute: LegalRetailerVietnamRoute,LegalReturnsRoute: LegalReturnsRoute,LegalTicketingGlobalRoute: LegalTicketingGlobalRoute,LegalTicketingVietnamRoute: LegalTicketingVietnamRoute,OrdersClaimRoute: OrdersClaimRoute,PlatformAiRoute: PlatformAiRoute,PlatformAiEnrichmentRoute: PlatformAiEnrichmentRoute,PlatformAiSuiteRoute: PlatformAiSuiteRoute,PlatformAiToolsRoute: PlatformAiToolsRoute,PlatformAnalyticsRoute: PlatformAnalyticsRoute,PlatformAutomationsRoute: PlatformAutomationsRoute,PlatformBookingsRoute: PlatformBookingsRoute,PlatformCardsRoute: PlatformCardsRoute,PlatformContactsRoute: PlatformContactsRoute,PlatformContractsRoute: PlatformContractsRoute,PlatformCrmRoute: PlatformCrmRoute,PlatformEventsRoute: PlatformEventsRoute,PlatformIdentityAndSharingRoute: PlatformIdentityAndSharingRoute,PlatformIntegrationsRoute: PlatformIntegrationsRoute,PlatformMeetingsRoute: PlatformMeetingsRoute,PlatformNfcRoute: PlatformNfcRoute,PlatformPipelinesRoute: PlatformPipelinesRoute,PlatformReviewsRoute: PlatformReviewsRoute,PlatformRunYourBusinessRoute: PlatformRunYourBusinessRoute,PlatformScoutRoute: PlatformScoutRoute,PlatformSharingRoute: PlatformSharingRoute,PlatformTasksRoute: PlatformTasksRoute,QuoteTokenRoute: QuoteTokenRoute,SaleIdRoute: SaleIdRoute,Shop24ktGoldRoute: Shop24ktGoldRoute,ShopBambooRoute: ShopBambooRoute,ShopBlackPvcRoute: ShopBlackPvcRoute,ShopGoogleReviewRoute: ShopGoogleReviewRoute,ShopMetalRoute: ShopMetalRoute,ShopWhitePvcRoute: ShopWhitePvcRoute,SolutionsEnterpriseRoute: SolutionsEnterpriseRoute,SolutionsFoundersRoute: SolutionsFoundersRoute,SolutionsRealEstateRoute: SolutionsRealEstateRoute,SolutionsSalesRoute: SolutionsSalesRoute,ViAboutRoute: ViAboutRoute,ViArticlesRoute: ViArticlesRouteWithChildren,ViContactRoute: ViContactRoute,ViHelpRoute: ViHelpRouteWithChildren,ViLegalGuidelinesRoute: ViLegalGuidelinesRoute,ViPricingRoute: ViPricingRoute,ViPrivacyRoute: ViPrivacyRoute,ViSecurityRoute: ViSecurityRoute,ViShopRoute: ViShopRoute,ViTeamsRoute: ViTeamsRoute,ViTermsRoute: ViTermsRoute,AiIndexRoute: AiIndexRoute,ElIndexRoute: ElIndexRoute,HomeIndexRoute: HomeIndexRoute,LegalIndexRoute: LegalIndexRoute,PlatformIndexRoute: PlatformIndexRoute,SolutionsIndexRoute: SolutionsIndexRoute,ViIndexRoute: ViIndexRoute,CheckoutIdSuccessRoute: CheckoutIdSuccessRoute,ElPlatformAiRoute: ElPlatformAiRoute,ElPlatformAiEnrichmentRoute: ElPlatformAiEnrichmentRoute,ElPlatformAiSuiteRoute: ElPlatformAiSuiteRoute,ElPlatformAiToolsRoute: ElPlatformAiToolsRoute,ElPlatformAnalyticsRoute: ElPlatformAnalyticsRoute,ElPlatformAutomationsRoute: ElPlatformAutomationsRoute,ElPlatformBookingsRoute: ElPlatformBookingsRoute,ElPlatformCardsRoute: ElPlatformCardsRoute,ElPlatformContactsRoute: ElPlatformContactsRoute,ElPlatformContractsRoute: ElPlatformContractsRoute,ElPlatformCrmRoute: ElPlatformCrmRoute,ElPlatformIdentityAndSharingRoute: ElPlatformIdentityAndSharingRoute,ElPlatformIntegrationsRoute: ElPlatformIntegrationsRoute,ElPlatformNfcRoute: ElPlatformNfcRoute,ElPlatformPipelinesRoute: ElPlatformPipelinesRoute,ElPlatformReviewsRoute: ElPlatformReviewsRoute,ElPlatformRunYourBusinessRoute: ElPlatformRunYourBusinessRoute,ElPlatformSharingRoute: ElPlatformSharingRoute,ElShop24ktGoldRoute: ElShop24ktGoldRoute,ElShopBambooRoute: ElShopBambooRoute,ElShopBlackPvcRoute: ElShopBlackPvcRoute,ElShopGoogleReviewRoute: ElShopGoogleReviewRoute,ElShopMetalRoute: ElShopMetalRoute,ElShopWhitePvcRoute: ElShopWhitePvcRoute,ElSolutionsEnterpriseRoute: ElSolutionsEnterpriseRoute,ElSolutionsFoundersRoute: ElSolutionsFoundersRoute,ElSolutionsRealEstateRoute: ElSolutionsRealEstateRoute,ElSolutionsSalesRoute: ElSolutionsSalesRoute,OrdersIdCustomizeRoute: OrdersIdCustomizeRoute,OrdersIdInvoiceRoute: OrdersIdInvoiceRoute,OrdersIdStatusRoute: OrdersIdStatusRoute,PlatformNetworkingEmailSignatureRoute: PlatformNetworkingEmailSignatureRoute,PlatformNetworkingLeadExchangeRoute: PlatformNetworkingLeadExchangeRoute,PlatformNetworkingPinProtectionRoute: PlatformNetworkingPinProtectionRoute,PlatformNetworkingQrCodeRoute: PlatformNetworkingQrCodeRoute,PlatformNetworkingWalletRoute: PlatformNetworkingWalletRoute,PlatformNetworkingWelcomeEmailRoute: PlatformNetworkingWelcomeEmailRoute,ViAiContractGeneratorRoute: ViAiContractGeneratorRoute,ViAiEmailWriterRoute: ViAiEmailWriterRoute,ViAiLeadFinderRoute: ViAiLeadFinderRoute,ViLegalAffiliateGlobalRoute: ViLegalAffiliateGlobalRoute,ViLegalAffiliateVietnamRoute: ViLegalAffiliateVietnamRoute,ViLegalAmlGlobalRoute: ViLegalAmlGlobalRoute,ViLegalAmlVietnamRoute: ViLegalAmlVietnamRoute,ViLegalAntiSpamRoute: ViLegalAntiSpamRoute,ViLegalKycGlobalRoute: ViLegalKycGlobalRoute,ViLegalKycVietnamRoute: ViLegalKycVietnamRoute,ViLegalRetailerGlobalRoute: ViLegalRetailerGlobalRoute,ViLegalRetailerVietnamRoute: ViLegalRetailerVietnamRoute,ViLegalReturnsRoute: ViLegalReturnsRoute,ViLegalTicketingGlobalRoute: ViLegalTicketingGlobalRoute,ViLegalTicketingVietnamRoute: ViLegalTicketingVietnamRoute,ViPlatformAiRoute: ViPlatformAiRoute,ViPlatformAiEnrichmentRoute: ViPlatformAiEnrichmentRoute,ViPlatformAiSuiteRoute: ViPlatformAiSuiteRoute,ViPlatformAiToolsRoute: ViPlatformAiToolsRoute,ViPlatformAnalyticsRoute: ViPlatformAnalyticsRoute,ViPlatformAutomationsRoute: ViPlatformAutomationsRoute,ViPlatformBookingsRoute: ViPlatformBookingsRoute,ViPlatformCardsRoute: ViPlatformCardsRoute,ViPlatformContactsRoute: ViPlatformContactsRoute,ViPlatformContractsRoute: ViPlatformContractsRoute,ViPlatformCrmRoute: ViPlatformCrmRoute,ViPlatformEventsRoute: ViPlatformEventsRoute,ViPlatformIdentityAndSharingRoute: ViPlatformIdentityAndSharingRoute,ViPlatformIntegrationsRoute: ViPlatformIntegrationsRoute,ViPlatformMeetingsRoute: ViPlatformMeetingsRoute,ViPlatformNfcRoute: ViPlatformNfcRoute,ViPlatformPipelinesRoute: ViPlatformPipelinesRoute,ViPlatformReviewsRoute: ViPlatformReviewsRoute,ViPlatformRunYourBusinessRoute: ViPlatformRunYourBusinessRoute,ViPlatformScoutRoute: ViPlatformScoutRoute,ViPlatformSharingRoute: ViPlatformSharingRoute,ViPlatformTasksRoute: ViPlatformTasksRoute,ViShop24ktGoldRoute: ViShop24ktGoldRoute,ViShopBambooRoute: ViShopBambooRoute,ViShopBlackPvcRoute: ViShopBlackPvcRoute,ViShopGoogleReviewRoute: ViShopGoogleReviewRoute,ViShopMetalRoute: ViShopMetalRoute,ViShopWhitePvcRoute: ViShopWhitePvcRoute,ViSolutionsEnterpriseRoute: ViSolutionsEnterpriseRoute,ViSolutionsFoundersRoute: ViSolutionsFoundersRoute,ViSolutionsRealEstateRoute: ViSolutionsRealEstateRoute,ViSolutionsSalesRoute: ViSolutionsSalesRoute,ElPlatformIndexRoute: ElPlatformIndexRoute,ElSolutionsIndexRoute: ElSolutionsIndexRoute,PlatformNetworkingIndexRoute: PlatformNetworkingIndexRoute,ViAiIndexRoute: ViAiIndexRoute,ViLegalIndexRoute: ViLegalIndexRoute,ViPlatformIndexRoute: ViPlatformIndexRoute,ViSolutionsIndexRoute: ViSolutionsIndexRoute,ViPlatformNetworkingEmailSignatureRoute: ViPlatformNetworkingEmailSignatureRoute,ViPlatformNetworkingLeadExchangeRoute: ViPlatformNetworkingLeadExchangeRoute,ViPlatformNetworkingPinProtectionRoute: ViPlatformNetworkingPinProtectionRoute,ViPlatformNetworkingQrCodeRoute: ViPlatformNetworkingQrCodeRoute,ViPlatformNetworkingWalletRoute: ViPlatformNetworkingWalletRoute,ViPlatformNetworkingWelcomeEmailRoute: ViPlatformNetworkingWelcomeEmailRoute,ViPlatformNetworkingIndexRoute: ViPlatformNetworkingIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)